import type { SelectableCareOrder } from './SelectableCareOrder';

/**
 * Returns care orders that can be shown in the compatible-care-orders blotter.
 *
 * A row is compatible when it is not currently a member and is nettable. In modification mode,
 * removed original netting members are also included so users can add them back even if they are
 * no longer generally nettable.
 */
export function getCompatibleCareOrders({
  allCareOrders,
  isModificationMode,
}: {
  allCareOrders: SelectableCareOrder[];
  isModificationMode: boolean;
}) {
  return allCareOrders.filter(careOrder => {
    if (careOrder.isSelected) {
      return false;
    }

    if (careOrder.canBeNetted) {
      return true;
    }

    return isModificationMode && careOrder.inNettedOrder;
  });
}
